// Util functions for cart item
import { CartItem, AllowedUserActionItem } from '@teko/cart/v2';

/**
 * return object of disabled actions of each Cart Item
 *
 * @param cartItem (CartItem)
 */
export const getDisabledUserActions = (cartItem: CartItem) => {
  const itemAllowedUserActions = cartItem.allowedUserActions || [];
  return {
    disableCheckItem: !itemAllowedUserActions.includes(
      AllowedUserActionItem.TOGGLE,
    ),
    disableChangeItemQuantity: !itemAllowedUserActions.includes(
      AllowedUserActionItem.CHANGE_QUANTITY,
    ),
    disableDeleteItem: !itemAllowedUserActions.includes(
      AllowedUserActionItem.DELETE,
    ),
    disableEditItemPrice: !itemAllowedUserActions.includes(
      AllowedUserActionItem.REQUEST_CONSULTATION_FEE,
    ),
    disableAddItemNote: !itemAllowedUserActions.includes(
      AllowedUserActionItem.ADD_NOTE,
    ),
  };
};

/**
 * logic to check if seller checkbox is enabled/disabled
 * return enable if at least one of its item's allowedUserActions contains TOGGLE value
 * if every item's allowedUserActions doesn't have TOGGLE value, return disable
 *
 * @param items: items of that seller
 */
export const checkEnableSellerCheckbox = (items: CartItem[]): boolean => {
  if (!items.length) return false;
  return items.some((item) =>
    !!item.allowedUserActions
      ? item.allowedUserActions.includes(AllowedUserActionItem.TOGGLE)
      : false,
  );
};
